import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Tooltip } from "@mantine/core";
import { useAtomValue } from "jotai";

import { isExtensionGateConnectedAtom } from "@prostocheck/shared";
import { Badge } from "@prostocheck/ui";

/**
 * A compact, always-visible read of `isExtensionGateConnectedAtom` — placed in
 * the app shell's header so every signed-in screen shows it. See
 * ai/docs/kep-signing.md.
 */
export const ExtensionGateBadge = () => {
  const { t } = useTranslation();
  const isConnected = useAtomValue(isExtensionGateConnectedAtom);

  // Still checking, right after app start — render nothing rather than flash a state.
  if (isConnected === null) return null;

  const badge = (
    <Badge tone={isConnected ? "success" : "neutral"}>
      {t(
        isConnected
          ? "extensionGate.badge.connected"
          : "extensionGate.badge.notConnected",
      )}
    </Badge>
  );

  if (isConnected) return badge;

  return (
    <Tooltip label={t("extensionGate.login.cta")}>
      <Link to="/extension">{badge}</Link>
    </Tooltip>
  );
};
